/* global axios */
import ApiClient from '../ApiClient';

// Parceiros/destinos de pendência (Bloco 2).
// - get() -> { interna: [], externa: [] } ativos (seletor do agente, T-01).
// - listManage() -> { parceiros: [{id, slug, nome, tipo, ativo}] } incl. inativos (gestão admin, T-06).
class ParceirosAPI extends ApiClient {
  constructor() {
    super('fandata/parceiros', { accountScoped: true });
  }

  listManage() {
    return axios.get(this.url, { params: { manage: true } });
  }

  create(parceiro) {
    return super.create({ parceiro });
  }

  update(id, parceiro) {
    return super.update(id, { parceiro });
  }
}

export default new ParceirosAPI();
